import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/shared/auth/auth.service';
import { ConsultasSqlApi, SectorApi, SucursalApi, Turno, TurnoApi } from 'app/shared/lb-sdk';
import { NgxSpinnerService } from 'ngx-spinner';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { of } from 'rxjs/observable/of';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
@Component({
  selector: 'app-grilla-turnos',
  templateUrl: './grilla-turnos.component.html',
  styleUrls: ['./grilla-turnos.component.css']
})
export class GrillaTurnosComponent implements OnInit {
  loginOk = false;
  estadoFiltro: number | null = null;
  fechaDesde: string | null = null;
  fechaHasta: string | null = null;
  dniFiltro = '';
  mostrarSpinner = false;
  turnos = [];
  turnosTodos = [];
  sucursalesDB = []
  isActive = true;
  sucursalFiltro = 0;
  turnosLlamados: Array<Turno> = [];
  // ultimoLlamado: Turno = new Turno({ idTurno: -1, numerador: -1, fecha: null, fechaAnulacion: null, horaEntrega: null, horaLlamado: null, horaPedido: null, idPuesto: 1, observaciones: null });
  blink: boolean = false;
  sectores: any;
  constructor(private sucursalApi: SucursalApi, private sectorApi: SectorApi, private consultaSql: ConsultasSqlApi, private spinner: NgxSpinnerService, public authService: AuthService, private router: Router) {


  }
  ngOnInit(): void {

    if (this.authService.userData) {
      this.loginOk = true
    }
    else {
      this.router.navigateByUrl('login-cliente')
    }

    this.fechaHasta = new Date().toISOString().slice(0, 19).replace('T', ' ');
    this.fechaDesde = new Date("2020-11-22 12:18:05").toISOString().slice(0, 19).replace('T', ' ');


    let hoy = new Date();

    let mes = hoy.getMonth() + 1;
    let dia = hoy.getDate();
    let anio = hoy.getFullYear();
    this.fechaDesde = `${anio}-${mes < 10 ? '0' : ''}${mes}-${dia < 10 ? '0' : ''}${dia}`;;
    this.fechaHasta = this.fechaDesde
    this.sucursalApi.find()
      .subscribe(respuesta => {
        this.sucursalesDB = respuesta;
       
      })

      this.consultaSql.GetStoreDinamic({
        nombreStore: "GetSectorGrilla",
        data: null
      })
        .subscribe(respuesta => {
          
          this.sectores = respuesta[0]
          this.estadoFiltro = 0;
          this.filtrarTurnos();
        })

    /*this.sectorApi.find()
      .subscribe((respuesta: any) => {
        console.log(respuesta)

        this.sectores = respuesta;
        this.estadoFiltro = 0;
        this.filtrarTurnos();
      })*/

  }
  /* this.turnoApi.find({ where: { and: [{ idSector: 2 }, { idEstado: 0 }] } })
    .subscribe((respuesta: any) => {
      console.log(respuesta)
      respuesta.forEach(element => {
        element.dni = element.dni.slice(-4)
      });
      this.turnosContactologiaDB = respuesta;
    })*/

  // 0-En espera, 1-Atendido, 2-Ausente, 3-Cancelado,4-Finalizado

  volver(){
    this.router.navigateByUrl('display-cliente-v2')
  }
  filtrarTurnos() {
    if (this.fechaDesde == '' || this.fechaHasta == '') {
      this.fechaHasta = new Date().toISOString().slice(0, 19).replace('T', ' ');
      this.fechaDesde = new Date("2020-11-22 12:18:05").toISOString().slice(0, 19).replace('T', ' ');
    }

    this.spinner.show();
    this.consultaSql.GetStoreDinamic({
      nombreStore: "GetTurnosByFilterBack",
      data: {
        IDSECTORFILTRO: this.estadoFiltro == 0 ? null : this.estadoFiltro,
        FECHADESDE: this.fechaDesde,
        FECHAHASTA: this.fechaHasta,
        IDSUCURSALFILTRO: this.sucursalFiltro == 0 ? null : this.sucursalFiltro,
      }
    })
      .subscribe(respuesta => {
        this.turnosTodos = respuesta[0] || [];
        this.aplicarFiltroDni();
        this.spinner.hide();
      }, () => {
        this.spinner.hide();
      })
  }

  aplicarFiltroDni(): void {
    const dni = (this.dniFiltro || '').toString().trim();
    if (!dni) {
      this.turnos = this.turnosTodos.slice();
      return;
    }

    this.turnos = this.turnosTodos.filter(turno => {
      const valor = (turno.dni == null ? '' : String(turno.dni));
      return valor.indexOf(dni) !== -1;
    });
  }

  exportarAExcel(): void {
    let aux = []
    // Reemplazar valores null con '' en todos los campos relevantes
    this.turnos.forEach(turno => {
      turno.idTurno = turno.idTurno || '';
      turno.fechaTurno = turno.fechaTurno || '';
      turno.fechaLlamado = turno.fechaLlamado || '';
      turno.fechaFinalizacion = turno.fechaFinalizacion || '';
      turno.idPuesto = turno.idPuesto || '';
      turno.fechaAnulacion = turno.fechaAnulacion || '';

      turno.idSector = turno.idSector || '';
      turno.nombre = turno.nombre || '';
      turno.apellido = turno.apellido || '';
      turno.dni = turno.dni || '';
      turno.sector = turno.sector || '';
      turno.estado = turno.estado || '';
      aux.push(turno)
      // Asegúrate de agregar más campos si es necesario
    });

    const total: any = {
      // Agrega los campos y realiza la suma o cálculo necesario
      idTurno: 'Total de Registros ' + this.turnos.length,
    };

    // Agregar la fila de total a la lista
    aux.push(total);

    // Ahora procede con la exportación a Excel
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(aux);
    XLSX.utils.book_append_sheet(wb, ws, 'Turnos');
    const nombreArchivo = 'turnos.xlsx';

    // Opciones de escritura
    const opcionesEscritura: XLSX.WritingOptions = { bookType: 'xlsx' };

    XLSX.writeFile(wb, nombreArchivo, opcionesEscritura);
  }

}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/grilla-turnos/grilla-turnos.component.ts